import React from 'react'

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from './Mui/TableCell';
import { withStyles } from '@material-ui/core/styles';

import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import {table as styles} from './Mui/styles';

class CustomTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render(){
    const {onSelectAllClick, sort, order, numSelected, rowCount, useCheck, rows, userRole } = this.props;

    return (
      <TableHead>
        <TableRow className="instatable-head-row">
          {
            (useCheck === true) && (
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={numSelected === rowCount}
                  onChange={onSelectAllClick}
                />
              </TableCell>
            )
          }

          {rows.filter(row => (row.requires === "admin" && userRole === "admin") ||
                              (row.requires === "expert" && (userRole === "admin" || userRole === "expert")) ||
                              (row.requires !== "admin" && row.requires !== "expert" )).map(row => {
            if (row.disableSort === true) {
              return (
                <TableCell
                  key={row.id}
                  padding={row.disablePadding ? 'none' : 'default'}
                >{row.label}</TableCell>
              )
            } else {
              return (
                <TableCell className="noFocus"
                  key={row.id}
                  padding={row.disablePadding ? 'none' : 'default'}
                  sortDirection={sort === row.id ? order : false}
                >
                  <Tooltip
                    title="Sort"
                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={sort === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              )
            }
          }, this)}
        </TableRow>
      </TableHead>
    )
  }
}

export default withStyles(styles)(CustomTableHead);



// WEBPACK FOOTER //
// ./src/js/components/CustomTableHead.js